import {Component, DestroyRef, inject, Input, OnInit} from '@angular/core';
import { EquipmentSupOutModel } from '../equipment.model';
import { AuthUser } from 'src/app/app-shared';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { ContentVisibilityService } from 'src/app/app-shared/services/content-visibility.service';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-equipment-details',
    templateUrl: './equipment-details.component.html',
    styleUrls: ['./equipment-details.component.scss'],
    standalone: false
})
export class EquipmentDetailsComponent implements OnInit {
  @Input() selectedItem: EquipmentSupOutModel;
  @Input() userData: AuthUser;
  @Input() mobile: boolean;

  showContent: boolean = true;
  private readonly destroyRef = inject(DestroyRef);
  private visibilitySubscription: Subscription;

  constructor(
    private visibilityService: ContentVisibilityService) { }

  ngOnInit(): void {
    this.visibilitySubscription = this.visibilityService.visibility$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(isVisible => {
        this.showContent = isVisible;
    });
  }

  showEquipmentRequest() {
    if(!!environment['useEquipmentRequest']) {
      return environment['useEquipmentRequest'];
    }
    return null;
  }

  ngOnDestroy() {
    if (this.visibilitySubscription) {
      this.visibilitySubscription.unsubscribe();
    }
  }
}
